import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { SignInArea } from "~/features/auth/_components/sign-in-area.js";

const signInSearchSchema = z.object({
  redirect: z.string().optional().default("/"),
});

export const Route = createFileRoute("/_not-authed/sign-in")({
  validateSearch: signInSearchSchema,
  beforeLoad: ({ context, search }) =>
  {
    if (context.auth?.isAuthenticated === true)
    {
      throw redirect({ to: search.redirect });
    }
  },
  component: SignInPage,
});

function SignInPage()
{
  const { redirect } = Route.useSearch();
  return (
    <div className="min-h-screen grid place-items-center px-4 py-8 overflow-x-hidden">
      <div className="w-full max-w-md">
        <SignInArea redirectTo={redirect} />
      </div>
    </div>
  );
}
